<mat-card>
    <mat-card-content>
        <p [innerHTML]="dialogData && dialogData.text ? dialogData.text : 'Recuerda que has abierto una bolsa de ofertas, cuyo tiempo de expiración es 00:' + ((dealsBagFillingService.minutesChronometer || 0) | number:'2.0-0') + ':' + ((dealsBagFillingService.secondsChronometer || 0) | number:'2.0-0')"></p>
        <div class="button-actions">
            <button *ngIf=!dialogData mat-stroked-button (click)='closeDialog(true)' type="button">Continuar</button>
            <button mat-button (click)='closeDialog(false)' type="button">{{ dialogData && dialogData.updateDeals ? dialogData.updateDeals : 'Quedarme aquí' }}</button>
        </div>
    </mat-card-content>
</mat-card>
